import { useTranslation } from 'react-i18next';

import { CloseIcon, InfoCircleIcon } from '@shared/assets/icons';
import { i18TranslationNS, Translation } from '@shared/config/i18n';
import { TabButton } from '@shared/ui/tabButton';

import s from './AppUpdateNotice.module.css';
import { useAppUpdateCheck } from '../../model';

const handleReload = () => window.location.reload();

// Floating notice shown on every page once a newer version of the portal has been deployed
// while this tab was open: asks the user to reload so they get the new bundle.
export const AppUpdateNotice = () => {
	const { t } = useTranslation(i18TranslationNS);
	const { isVisible, dismiss } = useAppUpdateCheck();

	const labels = {
		title: t(Translation.APP_UPDATE_TITLE),
		description: t(Translation.APP_UPDATE_DESCRIPTION),
		reload: t(Translation.APP_UPDATE_RELOAD),
		dismissAria: t(Translation.APP_UPDATE_DISMISS_ARIA),
	};

	return (
		<div className={s.appUpdateNotice_region} role='status' aria-live='polite'>
			{isVisible && (
				<section className={s.appUpdateNotice}>
					<InfoCircleIcon className={s.appUpdateNotice_icon} aria-hidden='true' focusable='false' />

					<div className={s.appUpdateNotice_text}>
						<h2 className='body-semibold-sm'>{labels.title}</h2>
						<p className='body-regular-sm'>{labels.description}</p>
					</div>

					<TabButton
						label={labels.reload}
						className='button-primary button-primary--icon-none'
						labelClassName='semantic-button-primary'
						onClick={handleReload}
					/>

					<TabButton
						leftIcon={CloseIcon}
						iconSize={16}
						className={s.appUpdateNotice_close}
						aria-label={labels.dismissAria}
						onClick={dismiss}
					/>
				</section>
			)}
		</div>
	);
};
